function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import { boostStates } from "../../constants";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var boostEntities = function boostEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byId: {},
    byStateAndUserId: {},
    byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_BOOSTS_SUCCESS:
      if (!action.response._embedded) return state;
      var byId = _objectSpread({}, state.byId);
      action.response._embedded.boosts.forEach(function (boost) {
        return byId[boost.id] = boost;
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_BOOSTLISTITEMBYBOOSTUSERIDANDBOOSTSTATEINANDDELETEDATISNULL_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (boostListItem) {
        return merge(byId, boostListItem.boostByBoostId);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_BOOSTSBYSTATEANDUSERID_SUCCESS:
      var byStateAndUserId = _objectSpread({}, state.byStateAndUserId);
      var key = [action.state, action.userId].join("-");
      var embedded = action.response._embedded ? action.response._embedded.boosts : [];
      byStateAndUserId[key] = embedded;
      return Object.assign({}, state, {
        byStateAndUserId: byStateAndUserId
      });
    case ActionTypes.GET_BOOSTSBYSTATEANDCURRENCYIDANDUSERIDANDOPERATIONSISEMPTY_SUCCESS:
      var byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty = _objectSpread({}, state.byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty);
      var key = [action.state, action.currencyId, action.userId].join("-");
      var embedded = action.response._embedded ? action.response._embedded.boosts : [];
      byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty[key] = embedded;
      return Object.assign({}, state, {
        byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty: byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty
      });
    case ActionTypes.GET_EVENTLISTITEMSBYUSERIDANDEVENTTYPEIDIN_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (eventListItem) {
        return merge(byId, eventListItem.boostById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_OPERATIONFORMBYINVESTMENTITEMIDANDUSERID_SUCCESS:
      var byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty = _objectSpread({}, state.byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty);
      merge(byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty, action.response.boostsByStateAndCurrencyIdAndUserIdAndOperationsIsEmpty);
      return Object.assign({}, state, {
        byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty: byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty
      });
    case ActionTypes.LOGIN_SUCCESS:
    case ActionTypes.GET_AUTHENTICATION_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var key = action.response.userId;
      var listItemArr = action.response.notificationListItemsByUserId[key];
      if (listItemArr) listItemArr.forEach(function (listItem) {
        return merge(byId, listItem.boostById);
      });
      var listItemArr = action.response.notificationListItemsByUserIdAndViewedAtIsNull[key];
      if (listItemArr) listItemArr.forEach(function (listItem) {
        return merge(byId, listItem.boostById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERID_SUCCESS:
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (notificationListItem) {
        return merge(byId, notificationListItem.boostById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_NOTIFICATIONTABBYUSERID_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.notificationListItemsByUserId[action.userId].forEach(function (listItem) {
        return merge(byId, listItem.boostById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    default:
      return state;
  }
};
export default boostEntities;